// src/routes/ask/canvas/index.tsx
// /ask/canvas — redirects to /agent (canvas-only cleanup).
// The canvas experience now lives exclusively at /agent.
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/ask/canvas/')({
  beforeLoad: () => {
    throw redirect({ to: '/agent', replace: true, search: { q: undefined } })
  },
})
